<template>
  <div class="w-full mt-20 md:px-2">
    <div class="w-full">
      <div class="flex justify-center items-center w-inherit pb-8">
        <div class="w-full mx-auto w-inherit pb-8">
          <div class="w-full text-right mb-4">
            <nx-button type="success" @click="show.create = true">Create a Category</nx-button>
            <nx-button class="ml-2" @click="show.reorder = true">Reorder Categories</nx-button>
          </div>

          <div class="flex flex-col mx-auto w-inherit pb-8">
            <div class="w-full mb-4" v-for="category in categories" :key="category.slug">
              <channel-category-admin-item :category="category"></channel-category-admin-item>

              <channel-table :category="category"></channel-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <portal to="modal-portal">
      <channel-category-create-form
        v-if="show.create"
        @close="show.create = false"
        @success="success('create')"
      />
    </portal>

    <portal to="modal-portal">
      <channel-category-reorder-form
        v-if="show.reorder"
        :categories="categories"
        @close="show.reorder = false"
        @success="success('reorder')"
      />
    </portal>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <router-link class="breadcrumb-link" :to="{name: 'admin'}">Admin</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Channels</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import ChannelCategoryCreateForm from "@/components/Forms/ChannelCategoryCreateForm"
import ChannelCategoryReorderForm from "@/components/Forms/ChannelCategoryReorderForm"
import ChannelCategoryAdminItem from "@/components/Items/ChannelCategoryAdminItem"
import ChannelTable from "@/components/Tables/ChannelTable"
import { mapActions, mapGetters } from "vuex"
import { EventBus } from "@/events"
import { ChevronRightIcon } from "vue-feather-icons"

export default {
  name: "Channels",
  components: {
    ChannelCategoryCreateForm,
    ChannelCategoryReorderForm,
    ChannelCategoryAdminItem,
    ChannelTable,
    ChevronRightIcon
  },
  data() {
    return {
      loading: false,
      show: {
        create: false,
        reorder: false
      }
    }
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    })
  },
  watch: {
    $route: {
      handler() {
        this.fetch()
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      fetch: "categories/fetch"
    }),
    success(form) {
      this.show[form] = false
      this.fetch()
    }
  },
  mounted() {
    EventBus.$on("channel:update", () => this.fetch())
  }
}
</script>
